import script from "./monitorLive.vue?vue&type=script&setup=true&lang=js"
export * from "./monitorLive.vue?vue&type=script&setup=true&lang=js"

import "./monitorLive.vue?vue&type=style&index=0&id=78aa9b0a&lang=scss"

const __exports__ = script;

export default __exports__